var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAddDomisili(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.5C10.6193 9.5 9.5 10.6193 9.5 12V36C9.5 37.3807 10.6193 38.5 12 38.5H36C37.3807 38.5 38.5 37.3807 38.5 36V12C38.5 10.6193 37.3807 9.5 36 9.5H12ZM6.5 12C6.5 8.96243 8.96243 6.5 12 6.5H36C39.0376 6.5 41.5 8.96243 41.5 12V36C41.5 39.0376 39.0376 41.5 36 41.5H12C8.96243 41.5 6.5 39.0376 6.5 36V12Z",
    fill: "#00AA4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 24C16.5 23.1716 17.1716 22.5 18 22.5H30C30.8284 22.5 31.5 23.1716 31.5 24C31.5 24.8284 30.8284 25.5 30 25.5H18C17.1716 25.5 16.5 24.8284 16.5 24Z",
    fill: "#00AA4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 16.5C24.8284 16.5 25.5 17.1716 25.5 18V30C25.5 30.8284 24.8284 31.5 24 31.5C23.1716 31.5 22.5 30.8284 22.5 30V18C22.5 17.1716 23.1716 16.5 24 16.5Z",
    fill: "#00AA4E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddDomisili);
export default __webpack_public_path__ + "static/media/icon_add_domisili.01bafa23f298539a63dd5db737f346df.svg";
export { ForwardRef as ReactComponent };